import React from "react";
import tw, { css } from "twin.macro";

interface Props {
  icon?: React.ReactNode;
  header?: number | string | any;
  className?: string | undefined;
  key?: number | string;
  headerBeforeIcon?: boolean;
  headerClassName?: string;
  preIconContent?: React.ReactNode;
}

const styles = css`
  ${tw`flex flex-col justify-center items-center bg-white rounded-xl border-2 shadow-lg my-2 mx-2 px-4 py-8`}
  > h3 {
    ${tw`rounded-full mx-auto h-24 w-24 flex items-center justify-center text-center text-turquoise-dark text-4xl sm:text-5xl font-black bg-turquoise-light`}
  }
  > .cardIcon {
    ${tw`mx-auto flex items-center justify-center text-center h-32 w-32`}
  }
`;

const Card: React.FC<Props> = ({ header, headerClassName, children, className, preIconContent, icon, headerBeforeIcon, ...rest }) => {
  const content = icon
    ? css`
        ${tw`w-full mt-6 mb-10 mx-auto text-center max-w-prose text-xl`}
      `
    : css`
        ${tw`w-full text-center text-xl sm:text-2xl my-10 sm:my-16 mx-auto sm:mx-1`}
      `;
  return (
    <div css={styles} className={className} {...rest}>
      {headerBeforeIcon && header && <h3 className={headerClassName}>{header}</h3>}
      {preIconContent && <p className="preIconContent">{preIconContent}</p>}
      {icon && <div className="cardIcon">{icon}</div>}
      {!headerBeforeIcon && header && <h3>{header}</h3>}
      {/* A div, not a p: card content contains block elements (lists, divs, buttons) */}
      <div className="cardContent" css={content}>
        {children}
      </div>
    </div>
  );
};

export default Card;
